import React from 'react';
import styled from 'styled-components';

const StyledLightsGlow = styled.img`
	position: absolute;
	top: 33%;
	right: 10.5%;
	opacity: ${({ theme }) => theme.theming.nightThemeGradientOpacity};
	transition: opacity ${({ theme }) => theme.theming.nightDayTransitionDuration};
	transform: rotate(35deg);
	z-index: -1;
`;

const StandingLampNightLights = () => <StyledLightsGlow src="./assets/images/ljos-vinstra.png" alt="Ljós vinstra" />;

export default StandingLampNightLights;
